import { render, staticRenderFns } from "./registerModel.vue?vue&type=template&id=52920dd8&scoped=true"
import script from "./registerModel.vue?vue&type=script&lang=js"
export * from "./registerModel.vue?vue&type=script&lang=js"
import style0 from "./registerModel.vue?vue&type=style&index=0&id=52920dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52920dd8",
  null
  
)

export default component.exports